export enum AnnouncementMatchingListApprovalStatus {
  NotApproved = 1,
  Approved = 2,
  Rejected = 3,
}
